import { Column } from 'react-table';

import { DisciplinaryActionDueReportRecordDto } from 'api';
import { ExaminerStatusLabels } from 'components';
import { formatDate } from 'utils';

export const columns: Column<DisciplinaryActionDueReportRecordDto>[] = [
  {
    Header: ' ',
    disableSortBy: true,
    columns: [
      {
        Header: 'First Name',
        accessor: 'examinerFirstName',
        width: '100px',
      },
      {
        Header: 'Last Name',
        accessor: 'examinerLastName',
        width: '100px',
      },
      {
        Header: 'Examiner number',
        accessor: 'examinerNumber',
        width: '80px',
      },
      {
        Header: 'Review Date',
        accessor: 'reviewDate',
        width: '100px',
        Cell: (x) => <>{formatDate(x.value)}</>,
      },
      {
        Header: 'Warning Type',
        accessor: 'warningTypeName',
        width: '120px',
      },
    ],
  },
  {
    Header: 'Examiner main centre',
    disableSortBy: true,
    columns: [
      {
        Header: 'Speaking',
        width: '220px',
        accessor: 'examinerMainSpeakingCentreName',
      },
      {
        Header: 'Writing',
        width: '220px',
        accessor: 'examinerMainWritingCentreName',
      },
    ],
  },
  {
    Header: ' ',
    disableSortBy: true,
    columns: [
      {
        disableSortBy: true,
        Header: 'Statuses',
        accessor: 'examinerStatuses',
        Cell: (x) => <ExaminerStatusLabels examinerStatuses={x.value} />,
      },
    ],
  },
];
